import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.primary.main,
    fontFamily: 'Dazzed',
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '24px'
  }
}))

const DazzedHeading13 = ({ className, children }) => {
  const classes = useStyles()

  return <div className={[classes.heading, className].join(' ')}>{children}</div>
}

export default DazzedHeading13
